export const API_KEY = "AIzaSyBAyhmJ6oCRZhUohJ-97zZtmOd7neDOlaA";

export default API_KEY;
